// @flow
import { combineEpics, ActionsObservable } from 'redux-observable';
import createDebugger from 'debug';
import * as Sentry from '@sentry/browser';
import { FETCH_SUCCESS as FETCH_PROFILE_SUCCESS } from 'modules/profile/action-types';
import { GLOBAL_ERROR_THROW, GLOBAL_ERROR_CAUGHT } from './action-types';
import * as RRR from 'react-router-redux';
const debug = createDebugger('modules:errors');

if (process.env.SERVICES_SENTRY_ENABLED) {
  Sentry.init({
    dsn: 'https://5e89b286bf4743469c578b7812477d5f@o378897.ingest.sentry.io/6157663',
    release: process.env.__VERSION__,
    environment: process.env.ENV || 'development',
    maxBreadcrumbs: 5,
  });
}

const profileTrackingEpic = (action$: ActionsObservable<*>) =>
  action$
    .ofType(FETCH_PROFILE_SUCCESS)
    .filter(() => process.env.SERVICES_SENTRY_ENABLED)
    .do(({ payload }) => {
      debug('Initializing Sentry user:', payload);
      try {
        const trackedUser = {
          id: payload.guid,
          isTrialCompany: payload.company.trialCompany,
          enclaveInboxLimit: payload.company.maxIngestEmailsCount,
          firstVisitDate: payload.activationDate
        };
        Sentry.configureScope(scope => {
          scope.setUser(trackedUser);
        });

        debug('Initialized user', trackedUser);
      } catch (err) {
        debug('Sentry user could not be initialized. Adblocker?', payload, err);
      }
    })
    .ignoreElements();

const handleGlobalError = (action$, store) =>
  action$.ofType(GLOBAL_ERROR_THROW).mapTo(RRR.push('/error'));

export default combineEpics(profileTrackingEpic, handleGlobalError);



// WEBPACK FOOTER //
// ./src/app/modules/errors/epics.js